export default {
    data() {
        return {
            startYear: 2007,
            filters: {},
            models: [],
            updatingFromSaved: false,
        }
    },

    props: {
        vehicleClass: {
            required: true,
            type: String,
        },

        currentFilters: {
            required: false,
        },
    },

    mounted() {
        this.filters.date.year = this.currentYear;
        this.filters.comparison.year = this.lastYear;

        if (! _.isEmpty(this.currentFilters)) {
            // this.filters = this.currentFilters;
            _.forEach(this.currentFilters, (filter, group) => {
                _.forEach(filter, (value, filterName) => {
                    this.filters[group][filterName] = value;
                });
            });
        }

        if (! _.isEmpty(this.filters.vehicle.makes)) {
            this.getModels();
        }

        _.defer(() => {
            if (this.filters.registration.type == 'used-imports') {
                bus.$emit('show-used-only-graphs');
            }

            if (this.filters.registration.type == 'new-imports') {
                bus.$emit('show-new-import-graphs');
            }
        });

        bus.$on('load-filter', (settings) => {
            this.updatingFromSaved = true;
            this.filters = _.cloneDeep(settings);

            _.defer(() => {
                this.filterResults(true);
                this.updatingFromSaved = false;
            });
        });

        this.$watch('filters', () => {
            if (! this.updatingFromSaved) {
                this.broadcastCurrentFilters();
            }
        }, { deep: true })

        this.broadcastCurrentFilters();
    },

    computed: {
        // Get the current year
        currentYear() {
            return parseInt(moment().format('YYYY'));
        },

        // Get last year
        lastYear() {
            return parseInt(moment().subtract(1, 'year').format('YYYY'));
        },

        // Generate the years between the set start year and
        // the current year (inclusive)
        years() {
            let years = [];

            for (var i=this.currentYear; i>=this.startYear; i--) {
                years.push(i);
            }

            return years;
        },

        // Generate the days of the month
        days() {
            let days = [];
            let firstDay = 1;
            let lastDay = 31;

            for (var i=firstDay; i<=lastDay; i++) {
                days.push(i);
            }

            return days;
        },

        // Check if there are any models set
        hasModels() {
            return ! _.isEmpty(this.models);
        },

        // The placeholder text for the models drop down
        modelsPlaceholder() {
            if (this.hasModels) {
                return 'Select Models';
            }

            return 'Please Select a Make';
        },
    },

    methods: {
        /**
         * Get the models for the selected makes
         */
        getModels() {
            this.$http.post('/motorstats/filters/models', {
                makes: this.filters.vehicle.makes,
                class: this.vehicleClass,
            }).then((response) => {
                this.models = response.data;
            });
        },

        /**
         * Remove models that belong to the given make
         * @param removed
         */
        removeMake(make) {
            this.filters.vehicle.models = _.reject(this.filters.vehicle.models, (model) => {
                return model.make_code == make.code;
            });
        },

        /**
         * Reset the models arrays
         */
        resetModels() {
            this.models = [];
            this.filters.vehicle.models = [];
        },

        /**
         * Tell the dashboard to reload data based on the set filters
         * @param fromSaved
         */
        filterResults() {
            if (document.documentElement.clientWidth <= 991) {
                bus.$emit('close-context-panel');
            }

            // bus.$emit('show-loading-overlay');
            bus.$emit('filters-updated', this.filters);
        },

        /**
         * Reset the dayFrom field
         */
        resetDayFrom() {
            if (_.isNull(this.filters.date.monthFrom)) {
                this.filters.date.dayFrom = null;
            }
        },

        /**
         * Reset the dayTo field
         */
        resetDayTo() {
            if (_.isNull(this.filters.date.monthTo)) {
                this.filters.date.dayTo = null;
            }
        },

        /**
         * Clear the used import filters
         */
        clearUsedImportFilters() {
            this.filters.registration.age = [];
            this.filters.registration.importedFrom = [];

            _.defer(() => {
                bus.$emit('context-panel-check-scroll');
            })
        },

        /**
         * Set the day back to null
         * @param filter
         * @return {boolean}
         */
        disableDay(filter) {
            return _.isNull(filter);
        },

        /**
         * Broadcast the current filters to components that are interested
         */
        broadcastCurrentFilters() {
            bus.$emit('current-filters', this.filters);
        }
    }

}